import React from "react";
import { Line } from "react-chartjs-2";

import { useRecoilValueLoadable } from "recoil";
import { asyncGetDashboardGraph } from "lib/store/dashboard";

import "./DashboardChart.scss";

export type DashboardChartProps = {
  cx?: string;
  unit: "week" | "month" | "day";
};

export const DashboardChart: React.FC<DashboardChartProps> = ({ unit }) => {
  const { state, contents } = useRecoilValueLoadable(
    asyncGetDashboardGraph({ unit })
  );

  const data = {
    labels: state === "hasValue" ? [...contents.labels] : [],
    datasets: state === "hasValue" ? [...contents.datasets] : [],
  };

  return (
    <Line
      data={data}
      options={{
        interaction: {
          mode: "index",
          intersect: false,
        },
        maintainAspectRatio: false,
        plugins: {
          legend: {
            display: false,
          },
        },
        scales: {
          y: {
            beginAtZero: true,
          },
        },
        // //@ts-ignore
        // tooltips: {
        //   mode: "index",
        //   intersect: false,
        // },
        hover: {
          intersect: false,
          mode: "index",
        },
      }}
    />
  );
};
